<template>
  <div>
    <div align="left"></div>
    <br />
    <div class="text-left">
      <h5 class="font-weight-bold text-primary">Claimed Benefit</h5>
      <b-row class="mt-4">
        <b-col md="2" class="my-1">
          <b-input-group>
            <b-input-group-text class="bg-white border-right-0" slot="prepend">
              <img src="@/assets/filter.svg" alt />
            </b-input-group-text>
            <b-dropdown
              text="Filter Data"
              variant="light"
              toggle-class="bg-white border-secondary text-primary border-left-0 pl-0"
              slot="append"
            >
              <div class="p-3">
                <b-row>
                  <b-col md="6">
                    <b-form-group
                      id="fieldset-1"
                      label="Member Type"
                      class="font-weight-bold"
                      label-for="input-1"
                    >
                      <b-form-select
                        v-model="membership_type"
                        name="member_type"
                        data-vv-as="Member Type"
                        class="mb-3"
                      >
                        <template v-slot:first>
                          <option value disabled>-- Member Type --</option>
                        </template>
                        <option value="gold">Gold</option>
                        <option value="silver">Silver</option>
                        <option value="gold2.0">Gold2.0</option>
                        <option value="silver2.0">Silver2.0</option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      id="fieldset-1"
                      label="Benefit Type"
                      class="font-weight-bold"
                      label-for="input-1"
                    >
                      <b-form-select
                        v-model="posm_type"
                        name="posm_type"
                        data-vv-as="Benefit Type"
                        class="mb-3"
                      >
                        <template v-slot:first>
                          <option value disabled>-- Benefit Type --</option>
                        </template>
                        <option
                          v-for="type_item in type_list"
                          :key="type_item.id"
                          :value="type_item.id"
                        >
                          {{ type_item.display }}
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="6">
                    <b-form-group
                      id="fieldset-1"
                      label="Name"
                      class="font-weight-bold"
                      label-for="input-1"
                    >
                      <input
                        placeholder="Name"
                        v-model="search_name"
                        name="name"
                        type="text"
                        data-vv-as="Name"
                        class="form-control"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      id="fieldset-1"
                      label="Phone Number"
                      class="font-weight-bold"
                      label-for="input-1"
                    >
                      <input
                        placeholder="Phone Number"
                        v-model="phone_number"
                        name="phone_number"
                        type="text"
                        data-vv-as="Phone Number"
                        class="form-control"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="6">
                    <b-form-group
                      id="fieldset-1"
                      label="Status"
                      class="font-weight-bold"
                      label-for="input-1"
                    >
                      <b-form-select
                        v-model="benefit_status"
                        name="benefit_status"
                        data-vv-as="Status"
                        class="mb-3"
                      >
                        <template v-slot:first>
                          <option value disabled>-- Status --</option>
                        </template>
                        <option value="claim-done">
                          Claim Done
                        </option>
                        <option value="on-process">
                          On Process
                        </option>
                        <option value="claim-received">
                          Received
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-form-group
                      id="fieldset-1"
                      label="Period"
                      class="font-weight-bold"
                      label-for="input-1"
                    >
                      <b-row>
                        <b-col>
                          <b-row class="m-0">
                            <b-col
                              class="
                                pr-0
                                form-control form-control-sm
                                img-calender-select
                                border-right-0
                              "
                              md="4"
                            >
                              <img
                                src="@/assets/ic-calendar-copy-30.svg"
                                width="20px"
                                alt
                                class="mt-n1"
                              />
                            </b-col>
                            <b-col md="6" class="px-0">
                              <datepicker
                                input-class="form-control form-control-sm text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                                placeholder="Select Date"
                                v-model="created_at_start"
                                :format="customFormatter"
                                :disabledDates="disabledDates"
                              ></datepicker>
                            </b-col>
                            <b-col align="left" md="1" class="px-0">
                              <b-col
                                align="left"
                                class="
                                  px-4
                                  form-control form-control-sm
                                  del-calender-select
                                  border-left-0
                                "
                                md="2"
                              >
                                <b-row align="left">
                                  <b-col>
                                    <b-button
                                      class="
                                        m-0
                                        p-0
                                        mt-n1
                                        bg-transparent
                                        border-0
                                      "
                                      @click="resetDateCreatedStart"
                                      variant="outline-light"
                                    >
                                      <i class="text-danger fas fa-times"></i>
                                    </b-button>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col>
                          <b-row class="m-0">
                            <b-col
                              class="
                                pr-0
                                form-control form-control-sm
                                img-calender-select
                                border-right-0
                              "
                              md="4"
                            >
                              <img
                                src="@/assets/ic-calendar-copy-30.svg"
                                width="20px"
                                alt
                                class="mt-n1"
                              />
                            </b-col>
                            <b-col md="6" class="px-0">
                              <datepicker
                                input-class="form-control form-control-sm text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                                placeholder="Select Date"
                                v-model="created_at_end"
                                :format="customFormatter"
                                :disabledDates="disabledDates"
                              ></datepicker>
                            </b-col>
                            <b-col align="left" md="1" class="px-0">
                              <b-col
                                align="left"
                                class="
                                  px-4
                                  form-control form-control-sm
                                  del-calender-select
                                  border-left-0
                                "
                                md="2"
                              >
                                <b-row align="left">
                                  <b-col>
                                    <b-button
                                      class="
                                        m-0
                                        p-0
                                        mt-n1
                                        bg-transparent
                                        border-0
                                      "
                                      @click="resetDateCreatedEnd"
                                      variant="outline-light"
                                    >
                                      <i class="text-danger fas fa-times"></i>
                                    </b-button>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-form-group>
                  </b-col>
                </b-row>
                <!-- <br /> -->
                <!-- <b-row>
                  <b-col md="12">
                    <b-form-group
                      id="fieldset-1"
                      label="Valid To Period"
                      class="font-weight-bold"
                      label-for="input-1"
                    >
                      <b-row>
                        <b-col>
                          <b-row class="m-0">
                            <b-col
                              class="
                                pr-0
                                form-control form-control-sm
                                img-calender-select
                                border-right-0
                              "
                              md="4"
                            >
                              <img
                                src="@/assets/ic-calendar-copy-30.svg"
                                width="25px"
                                alt
                                class="mt-n1"
                              />
                            </b-col>
                            <b-col md="6" class="px-0">
                              <datepicker
                                input-class="form-control form-control-sm text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                                placeholder="Select Date"
                                v-model="valid_until_start"
                                :format="customFormatter"
                                :disabledDates="disabledDates"
                              ></datepicker>
                            </b-col>
                            <b-col align="left" md="1" class="px-0">
                              <b-col
                                align="left"
                                class="
                                  px-4
                                  form-control form-control-sm
                                  del-calender-select
                                  border-left-0
                                "
                                md="2"
                              >
                                <b-row align="left">
                                  <b-col>
                                    <b-button
                                      class="
                                        m-0
                                        p-0
                                        mt-n1
                                        bg-transparent
                                        border-0
                                      "
                                      @click="resetDateValidStart"
                                      variant="outline-light"
                                    >
                                      <i class="text-danger fas fa-times"></i>
                                    </b-button>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col>
                          <b-row class="m-0">
                            <b-col
                              class="
                                pr-0
                                form-control form-control-sm
                                img-calender-select
                                border-right-0
                              "
                              md="4"
                            >
                              <img
                                src="@/assets/ic-calendar-copy-30.svg"
                                width="25px"
                                alt
                                class="mt-n1"
                              />
                            </b-col>
                            <b-col md="6" class="px-0">
                              <datepicker
                                input-class="form-control form-control-sm text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                                placeholder="Select Date"
                                v-model="valid_until_end"
                                :format="customFormatter"
                                :disabledDates="disabledDates"
                              ></datepicker>
                            </b-col>
                            <b-col align="left" md="1" class="px-0">
                              <b-col
                                align="left"
                                class="
                                  px-4
                                  form-control form-control-sm
                                  del-calender-select
                                  border-left-0
                                "
                                md="2"
                              >
                                <b-row align="left">
                                  <b-col>
                                    <b-button
                                      class="
                                        m-0
                                        p-0
                                        mt-n1
                                        bg-transparent
                                        border-0
                                      "
                                      @click="resetDateValidEnd"
                                      variant="outline-light"
                                    >
                                      <i class="text-danger fas fa-times"></i>
                                    </b-button>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-form-group>
                  </b-col>
                </b-row> -->
                <br />
                <b-row style="text-align-last: right">
                  <b-col>
                    <b-button
                      variant="outline-secondary"
                      @click="resetSearch()"
                      class="mr-3"
                      >Set Ulang</b-button
                    >
                    <b-button variant="primary" @click="search()"
                      >Cari</b-button
                    >
                  </b-col>
                </b-row>
              </div>
              <b-dropdown-item
                class="pointer-off"
                style="width: 450px"
              ></b-dropdown-item>
            </b-dropdown>
          </b-input-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form inline>
            Show &nbsp;
            <b-form-select
              v-model="perPage"
              :options="pageOptions"
            ></b-form-select>
            &nbsp; Records
          </b-form>
        </b-col>
        <b-col md="4" class="my-1"></b-col>
        <b-col md="4" class="my-1" align="right">
          <b-row>
            <b-col>
              <download-csv
                class="d-none"
                :data="CSV"
                name="claimed_benefit.csv"
                ref="DownloadCSV"
              ></download-csv>
              <b-button
                class="btn btn-warning px-4"
                style="padding-top: 6px; padding-bottom: 6px"
                :disabled="loadingCSV"
                @click="downloadCSV()"
              >
                <b-spinner label="Spinning" v-show="loadingCSV"></b-spinner>
                <i class="fas fa-file-download" style="font-size: 16px"></i> &nbsp;
                Export to CSV
              </b-button>
              <span>&nbsp;</span>
              <b-dropdown
                :variant="selected && selected.length === 0 ? 'secondary' : 'primary'"
                :disabled="selected && selected.length === 0"
                id="dropdown-1"
                text="Action   "
                size="lg"
                toggle-class="px-5"
              >
                <b-dropdown-item
                  @click="modalProcess = !modalProcess"
                  :disabled="onProcessValid"
                  >Process</b-dropdown-item
                >
                <b-dropdown-item
                  @click="modalDone = !modalDone"
                  :disabled="doneValid"
                  :class="doneValid ? 'text-primary' : 'text-danger'"
                  >Done</b-dropdown-item
                >
              </b-dropdown>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>
          We're sorry, we're not able to retrieve this information at the
          moment, please try back later
        </p>
      </section>
      <!-- Main table element -->
      <b-table
        v-else
        show-empty
        hover
        ref="selectableTable"
        selectable
        :select-mode="selectMode"
        @row-selected="onRowSelected"
        responsive="sm"
        stacked="md"
        :busy="loading"
        :items="getInfo"
        :fields="key"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:head(selected)="data">
          <span class="text-info">
            <b-form-checkbox
              v-model="allSelected"
              :indeterminate="indeterminate"
              aria-describedby="items"
              aria-controls="items"
              @change="toggleAll"
            ></b-form-checkbox>
          </span>
        </template>
        <template v-slot:cell(selected)="{ rowSelected, item, index }">
          <template v-if="rowSelected">
            <span aria-hidden="true">
              <b-form-checkbox
                id="checkbox-1"
                v-model="selected_field_true"
                name="checkbox-1"
                value="true"
                class="pointer-off"
                unchecked-value="false"
              ></b-form-checkbox>
            </span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">
              <b-form-checkbox
                id="checkbox-1"
                v-model="selected_field_false"
                name="checkbox-1"
                value="true"
                class="pointer-off"
                unchecked-value="false"
              ></b-form-checkbox>
            </span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>
        <template v-slot:cell(created_at_date_only)="{ value, item }">
          <p class="mb-0">{{ item.created_at_date_only }}</p>
          by {{ item.created_by_username }}
        </template>
        <template v-slot:cell(updated_at_date_only)="{ value, item }">
          <div v-if="item.updated_at_date_only == ''">-</div>
          <div v-else>
            <p class="mb-0">{{ item.updated_at_date_only }}</p>
            by {{ item.updated_by_username }}
          </div>
        </template>
        <template v-slot:cell(membership_type)="row">
          <p class="text-warning" v-if="row.value == 'gold'">
            <i class="fas fa-star"></i> Gold
          </p>
          <p class="text-secondary" v-else-if="row.value == 'silver'">
            <i class="fas fa-star"></i> Silver
          </p>
          <p class="text-warning" v-else-if="row.value == 'gold2.0'">
            <i class="fas fa-star"></i> Gold2.0
          </p>
          <p class="text-secondary" v-else-if="row.value == 'silver2.0'">
            <i class="fas fa-star"></i> Silver2.0
          </p>
        </template>
        <template v-slot:cell(status)="row">
          <p class="text-success" v-if="row.value == 'publish'">Publish</p>
          <p class="text-warning" v-else-if="row.value == 'archive'">Archive</p>
        </template>
        <template v-slot:cell(benefit_status)="row">
          <p style="color: #30cb9d" v-if="row.value == 'claim-done'">
            Claim Done
          </p>
          <p class="text-warning" v-else-if="row.value == 'on-process'">
            On Process
          </p>
          <p class="text-primary" v-else-if="row.value == 'claim-received'">
            Received
          </p>
        </template>
        <template v-slot:cell(benefit_type)="row">
          <label>{{ row.value }}</label>
        </template>
        <template v-slot:cell(benefit_category)="row">
          <label>{{ row.value }}</label>
        </template>
        <template v-slot:cell(action)="row">
          <!-- <b-link v-b-tooltip.hover title="Delete" class="mr-2" @click="del(row.item.id)">
            <img src="@/assets/rectangle.svg" alt />
          </b-link>-->
          <b-link @click="row.toggleDetails">
            <label class="text-primary" style="cursor: pointer">
              Detail <img src="@/assets/ic-drop-yellow-copy-46.svg" alt />
            </label>
          </b-link>
          <!-- <b-button
            size="sm"
            @click="row.toggleDetails"
          >{{ row.detailsShowing ? 'Hide' : 'Show' }} Details</b-button>-->
        </template>
        <template v-slot:row-details="row">
          <b-card>
            <ul>
              <li v-for="(value, key) in row.item.reasons" :key="key">
                <ul>
                  <li>Key : {{ key }}</li>
                  <li>Value : {{ value }}</li>
                </ul>
              </li>
            </ul>
          </b-card>
        </template>
      </b-table>

      <b-modal
        v-model="modalProcess"
        centered
        size="lg"
        hide-footer
        hide-header
      >
        <b-row>
          <b-col>
            <h2 class="text-primary font-weight-bold">ACTION - ON PROCESS</h2>
            <label>Order Summary</label>
            <b-table-simple responsive>
              <b-thead>
                <b-tr>
                  <b-th>Category</b-th>
                  <b-th>Type</b-th>
                  <b-th>Member Code</b-th>
                  <b-th>Name</b-th>
                  <b-th>No Contact</b-th>
                  <b-th>Receive Date</b-th>
                  <b-th>Status</b-th>
                </b-tr>
              </b-thead>
              <b-tr v-for="(data, idx) in selected" :key="idx">
                <b-td>
                  <label>{{ data.benefit_category }}</label>
                </b-td>
                <b-td>
                  <label>{{ data.benefit_type }}</label>
                </b-td>
                <b-td>{{ data.user_id }}</b-td>
                <b-td>{{ data.user_name }}</b-td>
                <b-td>{{ data.phone_number }}</b-td>
                <b-td>{{ data.benefit_claim_received_date }}</b-td>
                <b-td>
                  <p
                    style="color: #30cb9d"
                    v-if="data.benefit_status == 'claim-done'"
                  >
                    Claim Done
                  </p>
                  <p
                    class="text-warning"
                    v-else-if="data.benefit_status == 'on-process'"
                  >
                    On Process
                  </p>
                  <p
                    class="text-primary"
                    v-else-if="data.benefit_status == 'claim-received'"
                  >
                    Received
                  </p>
                </b-td>
              </b-tr>
            </b-table-simple>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8"></b-col>
          <b-col md="4" class="text-right">
            <b-button
              size="lg"
              variant="outline-secondary"
              class="mr-4"
              @click="modalProcess = !modalProcess"
              >CANCEL</b-button
            >
            <b-button size="lg" variant="primary" @click="OnProcess()"
              >ON PROCESS</b-button
            >
          </b-col>
        </b-row>
      </b-modal>

      <b-modal v-model="modalDone" centered size="lg" hide-footer hide-header>
        <b-row>
          <b-col>
            <h2 class="text-primary font-weight-bold">ACTION - DONE</h2>
            <label>Order Summary</label>
            <b-table-simple responsive>
              <b-thead>
                <b-tr>
                  <b-th>Category</b-th>
                  <b-th>Type</b-th>
                  <b-th>Member Code</b-th>
                  <b-th>Name</b-th>
                  <b-th>No Contact</b-th>
                  <b-th>On Process Date</b-th>
                  <b-th>Status</b-th>
                </b-tr>
              </b-thead>
              <b-tr v-for="(data, idx) in selected" :key="idx">
                <b-td>
                  <label>{{ data.benefit_category }}</label>
                </b-td>
                <b-td>
                  <label>{{ data.benefit_type }}</label>
                </b-td>
                <b-td>{{ data.user_id }}</b-td>
                <b-td>{{ data.user_name }}</b-td>
                <b-td>{{ data.phone_number }}</b-td>
                <b-td>{{ data.benefit_on_process_date }}</b-td>
                <b-td>
                  <p
                    style="color: #30cb9d"
                    v-if="data.benefit_status == 'claim-done'"
                  >
                    Claim Done
                  </p>
                  <p
                    class="text-warning"
                    v-else-if="data.benefit_status == 'on-process'"
                  >
                    On Process
                  </p>
                  <p
                    class="text-primary"
                    v-else-if="data.benefit_status == 'claim-received'"
                  >
                    Received
                  </p>
                </b-td>
              </b-tr>
            </b-table-simple>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8"></b-col>
          <b-col md="4" class="text-right">
            <b-button
              size="lg"
              variant="outline-secondary"
              class="mr-4"
              @click="modalDone = !modalDone"
              >CANCEL</b-button
            >
            <b-button size="lg" variant="primary" @click="Done()"
              >DONE</b-button
            >
          </b-col>
        </b-row>
      </b-modal>
      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">
          <div v-if="totalRows == 0 || totalRows == null">
            Showing 0 Records
          </div>
          <div v-else>
            Showing {{ fromPage[currentPage - 1] }} to
            {{ toPage[currentPage - 1] }} of {{ totalRows }} Records
          </div>
        </b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      loading: false,
      loadingCSV: false,
      modalProcess: false,
      modalDone: false,
      errored: false,
      items: [],
      vuex: [],
      selected: [],
      key: [
        {
          key: "selected",
          class: "text-center",
        },
        {
          key: "benefit_category",
          label: "Category",
          sortable: true,
          class: "text-center",
        },
        {
          key: "benefit_type",
          label: "Type",
          sortable: true,
          class: "text-center",
        },
        {
          key: "user_id",
          label: "Member Code",
          sortable: true,
          class: "text-center",
        },
        {
          key: "user_name",
          label: "Name",
          sortable: true,
          class: "text-center",
        },

        {
          key: "membership_type",
          label: "Member Type",
          sortable: true,
          class: "text-center",
        },
        {
          key: "phone_number",
          label: "No Contact",
          sortable: true,
          class: "text-center",
        },
        {
          key: "benefit_claim_received_date",
          label: "Received Date",
          sortable: true,
          class: "text-left",
        },
        {
          key: "benefit_on_process_date",
          label: "On Process Date",
          sortable: true,
          class: "text-left",
        },
        {
          key: "benefit_claim_done_date",
          label: "Done Date",
          sortable: true,
          class: "text-left",
        },
        {
          key: "benefit_status",
          label: "Status",
          sortable: true,
          class: "text-left",
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      type_list: [],
      filter: "",
      membership_type: "",
      phone_number: "",
      created_at_start: "",
      created_at_end: "",
      valid_until_start: "",
      valid_until_end: "",
      selectMode: "multi",
      search_name: "",
      customerShow: false,
      selected_field_true: true,
      selected_field_false: false,
      allSelected: false,
      indeterminate: false,
      fromPage: "",
      toPage: "",
      posm_type: "",
      benefit_status: "",
      CSV: [],
      disabledDates: {
        to: new Date("December 1, 2021 01:15:00"),
      },
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    onProcessValid() {
      if (this.selected && this.selected.find((x) => x.benefit_status === "claim-received")) {
        if (this.selected &&this.selected.find((x) => x.benefit_status === "on-process")) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    doneValid() {
      if (this.selected && this.selected.find((x) => x.benefit_status === "on-process")) {
        if (this.selected && this.selected.find((x) => x.benefit_status === "claim-received")) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
  },
  beforeCreate() {
    const formData = new FormData();
    formData.append("search_param", "");
    formData.append("limit", "1000");
    formData.append("page", "1");
    formData.append("sort_by", "");
    formData.append("is_sort_asc", true);
    this.$store
      .dispatch("BenefitTypeModule/getBenefitTypes", formData)
      .then((response) => {
        this.type_list = response.data.data.type_benefits || [];
        this.loading = false;
      })
      .catch((error) => {
        this.$swal({
          type: "error",
          title: "Oops...",
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
        this.loading = false;
      });
  },
  methods: {
    search() {
      this.$refs.selectableTable.refresh();
    },
    resetDateCreatedStart() {
      this.created_at_start = "";
    },
    resetDateCreatedEnd() {
      this.created_at_end = "";
    },
    resetDateValidStart() {
      this.valid_until_start = "";
    },
    resetDateValidEnd() {
      this.valid_until_end = "";
    },
    resetSearch() {
      this.$refs.selectableTable.refresh();
      this.membership_type = "";
      this.phone_number = "";
      this.search_name = "";
      this.posm_type = "";
      this.benefit_status = "";
      this.created_at_start = "";
      this.created_at_end = "";
    },
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", ctx.sortDesc);
      formData.append("name", this.search_name);
      formData.append("membership_type", this.membership_type);
      formData.append("phone_number", this.phone_number);
      formData.append("benefit_type", this.posm_type);
      formData.append("benefit_status", this.benefit_status);
      formData.append(
        "created_at_start",
        this.created_at_start != ""
          ? moment(this.created_at_start).format(`YYYY-MM-DDT`) + "00:00"
          : ""
      );
      formData.append(
        "created_at_end",
        this.created_at_end != ""
          ? moment(this.created_at_end).format("YYYY-MM-DDT") + "23:59"
          : ""
      );
      this.$store
        .dispatch("ClaimedBenefitModule/getClaimedBenefit", formData)
        .then((response) => {
          vm.totalRows = response.data.data.total_record;
          var from = [];
          var to = [];
          var sum = 0;
          for (let i = 1; i <= vm.currentPage; i++) {
            sum = i * vm.perPage;
            if (vm.totalRows <= sum) {
              from.push(sum - vm.perPage + 1);
              to.push(vm.totalRows - sum + sum);
            } else {
              from.push(sum - vm.perPage + 1);
              to.push(sum);
            }
          }
          this.fromPage = from;
          this.toPage = to;
          this.items = response.data.data.user_benefits || [];
          callback(response.data.data.user_benefits || []);
          this.loading = false;
        })
        .catch((error) => {
          this.$swal({
            type: "error",
            title: "Error!",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.loading = false;
          callback([]);
        });
      return null;
    },
    ReasonFilter(payload) {
      this.loading = true;
      this.$store
        .dispatch("RatingModule/getReasons", payload)
        .then((response) => {
          this.loading = false;
          this.$swal({
            type: "success",
            title: "Data Filtered",
            showConfirmButton: false,
            timer: 1500,
          });
        })
        .catch((error) => {
          this.loading = false;
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.serverError = error.response.data;
          console.log(error);
        });
    },
    onRowSelected(items) {
      this.selected = items;
    },
    submitStatus(status) {
      const formData = new FormData();
      $.each(this.selected, (key, value) => {
        formData.append("reason_id", value.id);
        formData.append("status", status);
      });
      $.each(formData.getAll("reason_id"), (key, value) => {
        console.log(value);
      });
      this.loading = true;
      const payload = "fm,lm,shipment";
      this.$store
        .dispatch("RatingModule/updateReasons", formData)
        .then((response) => {
          this.loading = false;
          this.$store.dispatch("RatingModule/getReasons", payload);
          this.$swal({
            type: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            timer: 1000,
          });
          console.log(response);
        })
        .catch((error) => {
          this.loading = false;
          this.serverError = error.response;
          console.log(error);
        });
    },
    toggleAll(checked) {
      this.selected = checked
        ? this.$refs.selectableTable.selectAllRows()
        : this.$refs.selectableTable.clearSelected();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    downloadCSV() {
      this.$swal({
        title: "Download CSV Report??",
        text: "Proses ini akan memakan waktu dan beban pada database",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya!",
        cancelButtonText: "Tidak",
      }).then((result) => {
        if (result.value) {
          this.loadingCSV = true;
          console.log(this.selected.length);
          if (this.selected && this.selected.length > 0) {
            this.CSV = this.selected;
            
            setTimeout(() => {
              this.loadingCSV = false;
              this.$refs.DownloadCSV.$el.click();
            }, 1000);
          } else {
            const formData = new FormData();

            const ctx = this.$refs.selectableTable;
            formData.append("search_param", ctx.filter);
            formData.append("limit", ctx.perPage);
            formData.append("page", ctx.currentPage);
            formData.append("sort_by", ctx.sortBy);
            formData.append("is_sort_asc", ctx.sortDesc);
            formData.append("name", this.search_name);
            formData.append("membership_type", this.membership_type);
            formData.append("phone_number", this.phone_number);
            formData.append("benefit_type", this.posm_type);
            formData.append("benefit_status", this.benefit_status);
            formData.append(
              "created_at_start",
              this.created_at_start != ""
                ? moment(this.created_at_start).format(`YYYY-MM-DDT`) + "00:00"
                : ""
            );
            formData.append(
              "created_at_end",
              this.created_at_end != ""
                ? moment(this.created_at_end).format("YYYY-MM-DDT") + "23:59"
                : ""
            );
            this.$store
              .dispatch("ClaimedBenefitModule/getClaimedBenefit", formData)
              .then((response) => {
                this.CSV = response.data.data.user_benefits || [];
                setTimeout(() => {
                  this.loadingCSV = false;
                  this.$refs.DownloadCSV.$el.click();
                }, 1000);
              })
              .catch((error) => {
                this.loadingCSV = false;
                callback([]);
              });
          }
        } else {
        }
      });
    },
    del(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("RatingModule/delReason", id);
          this.$swal("Deleted!", "Your file has been deleted.", "success");
        }
      });
    },
    OnProcess() {
      this.$swal({
        title: "Are you sure?",
        text: `You will process this benefits`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, change it!",
      }).then((result) => {
        if (result.value) {
          const formData = new FormData();
          $.each(this.selected, (key, value) => {
            formData.append("user_id", value.user_id);
            formData.append("benefit_id", value.benefit_id);
          });
          this.loading = true;
          this.$store
            .dispatch("ClaimedBenefitModule/postProcessBenefit", formData)
            .then((response) => {
              setTimeout(() => {
                this.modalProcess = false;
                this.loading = false;
                this.$refs.selectableTable.refresh();
                this.$swal({
                  type: "success",
                  title: "Your work has been saved",
                  showConfirmButton: false,
                  timer: 1000,
                });
              }, 2000);
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              this.serverError = error.response;
              console.log(error);
            });
        }
      });
    },
    Done() {
      this.$swal({
        title: "Are you sure?",
        text: `You will done this benefits`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, change it!",
      }).then((result) => {
        if (result.value) {
          const formData = new FormData();
          $.each(this.selected, (key, value) => {
            formData.append("user_id", value.user_id);
            formData.append("benefit_id", value.benefit_id);
          });
          this.loading = true;
          this.$store
            .dispatch("ClaimedBenefitModule/postReceivedBenefit", formData)
            .then((response) => {
              setTimeout(() => {
                this.modalDone = false;
                this.loading = false;
                this.$refs.selectableTable.refresh();
                this.$swal({
                  type: "success",
                  title: "Your work has been saved",
                  showConfirmButton: false,
                  timer: 1000,
                });
              }, 2000);
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              this.serverError = error.response;
              console.log(error);
            });
        }
      });
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },
  watch: {
    selected(newVal, oldVal) {
      if (newVal) {
        if (newVal.length === 0) {
          this.indeterminate = false;
          this.allSelected = false;
        } else if (newVal.length === this.items.length) {
          this.indeterminate = false;
          this.allSelected = true;
        } else {
          this.indeterminate = true;
          this.allSelected = false;
        }
      }
    },
  },
};
</script>

<style>
.pointer-off {
  pointer-events: none;
}
</style>
